import { createAction } from "redux-actions";
import moment from "moment";
import { saveAs } from "file-saver";
import { apiGet, apiPut, apiPost } from "util/api";
import getFilenameFromContentDisposition from "util/getFilenameFromContentDisposition";
import Immutable from "immutable";
import tabularizeFormData from "./tabularizeFormData";

import submissionPropsSelector from "./selectors";
import * as types from "./constants";

const cloneObject = obj => JSON.parse(JSON.stringify(obj));

/* eslint-disable max-len */
export const addProcessLogIndex = createAction(
  types.SUBMISSION_DETAIL_MODAL_ADD_CHECKED_INDEX
);
export const removeProcessLogIndex = createAction(
  types.SUBMISSION_DETAIL_MODAL_REMOVE_CHECKED_INDEX
);
export const submissionDataFetchRequest = createAction(
  types.SUBMISSION_DATA_FETCH_REQUEST
);
export const submissionDataFetchError = createAction(
  types.SUBMISSION_DATA_FETCH_ERROR
);
export const submissionDataFetchSuccess = createAction(
  types.SUBMISSION_DATA_FETCH_SUCCESS
);
export const submissionErrorListRequest = createAction(
  types.SUBMISSION_ERROR_LIST_REQUEST
);
export const submissionErrorListError = createAction(
  types.SUBMISSION_ERROR_LIST_ERROR
);
export const submissionErrorListSuccess = createAction(
  types.SUBMISSION_ERROR_LIST_SUCCESS
);

// Search Filters
export const setErrorClassFilter = createAction(types.SUBMISSION_ERROR_FILTER);
export const setRangeFilter = createAction(types.SUBMISSION_RANGE_FILTER);
export const setSearchFilter = createAction(types.SUBMISSION_SEARCH_FILTER);
export const setServerSearchFilter = createAction(
  types.SUBMISSION_SERVER_SEARCH_FILTER
);
export const serverSearchFetchKeysSuccess = createAction(
  types.SUBMISSION_SERVER_SEARCH_FILTER_SUCCESS
);
export const openDetailsModal = createAction(
  types.SUBMISSION_DETAILS_MODAL_OPEN
);
export const closeDetailsModal = createAction(
  types.SUBMISSION_DETAILS_MODAL_CLOSE
);
export const setDetailsModalData = createAction(
  types.SUBMISSION_DETAILS_MODAL_SET_DATA
);

// for the Details Modal
export const openJSONModal = createAction(types.SUBMISSION_OPEN_JSON_MODAL);
export const closeJSONModal = createAction(types.SUBMISSION_CLOSE_JSON_MODAL);

export const setSearchText = createAction(
  types.SUBMISSION_SET_FORM_DATA_SEARCH_TEXT
);

export const processLogUdateRequest = createAction(
  types.SUBMISSION_PROCESS_LOG_UPDATE_REQUEST
);
export const processLogDataFetchRequest = createAction(
  types.SUBMISSION_PROCESS_LOG_FETCH_REQUEST
);
export const processLogDataFetchSuccess = createAction(
  types.SUBMISSION_PROCESS_LOG_FETCH_SUCCESS
);
export const processLogDataFetchError = createAction(
  types.SUBMISSION_PROCESS_LOG_FETCH_ERROR
);

export const processLogDataInvalidate = createAction(
  types.SUBMISSION_PROCESS_LOG_INVALIDATE
);

export const processLogStatusUpdate = createAction(
  types.SUBMISSION_PROCESS_LOG_UPDATE_STATUS
);
export const processLogUpdateRow = createAction(
  types.SUBMISSION_PROCESS_LOG_UPDATE_ROW
);
export const processLogUpdateSuccess = createAction(
  types.SUBMISSION_PROCESS_LOG_UPDATE_SUCCESS
);
export const processLogUpdateError = createAction(
  types.SUBMISSION_PROCESS_LOG_UPDATE_ERROR
);
export const processLogToggleSelectAll = createAction(
  types.SUBMISSION_PROCESS_LOG_TOGGLE_SELECT_ALL
);

export const changeOrderSetSubmissionID = createAction(
  types.SUBMISSION_SET_CHANGE_ORDER_SUBMISSION_ID
);

export const formDataFetchRequest = createAction(
  types.SUBMISSION_FORM_DATA_FETCH_REQUEST
);
export const formDataFetchSuccess = createAction(
  types.SUBMISSION_FORM_DATA_FETCH_SUCCESS
);
export const formDataFetchError = createAction(
  types.SUBMISSION_FORM_DATA_FETCH_ERROR
);

export const formSourceFetchRequest = createAction(
  types.SUBMISSION_FORM_SOURCE_FETCH_REQUEST
);
export const formSourceFetchSuccess = createAction(
  types.SUBMISSION_FORM_SOURCE_FETCH_SUCCESS
);
export const formSourceFetchError = createAction(
  types.SUBMISSION_FORM_SOURCE_FETCH_ERROR
);

export const formDataModalOpen = createAction(
  types.SUBMISSION_FORM_DATA_MODAL_OPEN
);
export const formDataModalClose = createAction(
  types.SUBMISSION_FORM_DATA_MODAL_CLOSE
);

export const changeOrderModalOpen = createAction(
  types.SUBMISSION_CHANGE_MODAL_OPEN
);
export const changeOrderModalClose = createAction(
  types.SUBMISSION_CHANGE_MODAL_CLOSE
);

export const recallModalOpen = createAction(types.SUBMISSION_RECALL_MODAL_OPEN);
export const recallModalClose = createAction(
  types.SUBMISSION_RECALL_MODAL_CLOSE
);
export const recallSetDevice = createAction(types.SUBMISSION_RECALL_SET_DEVICE);

export const recallToDeviceRequest = createAction(
  types.SUBMISSION_RECALL_DEVICE_REQUEST
);
export const recallToDeviceSuccess = createAction(
  types.SUBMISSION_RECALL_DEVICE_SUCCESS
);
export const recallToDeviceError = createAction(
  types.SUBMISSION_RECALL_DEVICE_ERROR
);
export const recallConfirmationClose = createAction(
  types.SUBMISSION_RECALL_CONFIRM_MODAL_CLOSE
);

export const makeTemplateModalOpen = createAction(
  types.SUBMISSION_MAKE_TEMPLATE_MODAL_OPEN
);
export const makeTemplateModalClose = createAction(
  types.SUBMISSION_MAKE_TEMPLATE_MODAL_CLOSE
);
export const makeTemplateSetDevice = createAction(
  types.SUBMISSION_MAKE_TEMPLATE_SET_DEVICE
);

export const makeTemplateToDeviceRequest = createAction(
  types.SUBMISSION_SEND_TEMPLATE_DEVICE_REQUEST
);
export const makeTemplateToDeviceSuccess = createAction(
  types.SUBMISSION_SEND_TEMPLATE_DEVICE_SUCCESS
);
export const makeTemplateToDeviceError = createAction(
  types.SUBMISSION_SEND_TEMPLATE_DEVICE_ERROR
);
export const makeTemplateConfirmationClose = createAction(
  types.SUBMISSION_SEND_TEMPLATE_CONFIRM_MODAL_CLOSE
);

export const updatingRowRequest = createAction(types.SUBMISSION_UPDATING_ROW);
export const updatingRowSuccess = createAction(types.SUBMISSION_SUCCESS_ROW);
export const updatingRowError = createAction(types.SUBMISSION_ERROR_ROW);

export const deleteModalOpen = createAction(
  types.SUBMISSION_DELETE_CONFIRM_MODAL_OPEN
);
export const deleteModalClose = createAction(
  types.SUBMISSION_DELETE_CONFIRM_MODAL_CLOSE
);

export const setBulkAction = createAction(
  types.SUBMISSION_PROCESS_LOG_SET_ACTION
);

export const dmDevicesListFetchRequest = createAction(
  types.SUBMISSION_DEVICES_FETCH_REQUEST
);
export const dmDevicesListFetchSuccess = createAction(
  types.SUBMISSION_DEVICES_FETCH_SUCCESS
);
export const dmDevicesListFetchError = createAction(
  types.SUBMISSION_DEVICES_FETCH_ERROR
);

export const updateStoredProcessLog = createAction(
  types.SUBMISSION_UPDATE_STORED_PROCESS_LOG
);
export const updateFormDataProcessForm = createAction(
  types.SUBMISSION_UPDATE_STORED_PROCESS_FORM
);
export const changeOrderError = createAction(
  types.SUBMISSION_CHANGE_ORDER_ERROR
);

export const changeJSONModalLevels = createAction(
  types.SUBMISSION_CHANGE_JSON_LEVELS_VIEW
);
export const updateOneRow = createAction(types.SUBMISSION_UPDATE_ROW);

export const setDeviceToIssuing = submissionDeviceId => (
  dispatch,
  getState
) => {
  const { devices, modalData } = submissionPropsSelector(getState());
  // translate the stored submission_device, which is the device owner, to the device identifier
  const index = devices
    .map(dev => dev.identifier)
    .indexOf(submissionDeviceId || modalData.submission_id);

  // if device isn't found (eg if it was removed in DeviceMagic), can just send to another device
  const deviceName = index === -1 ? "" : devices[index].identifier;
  const deviceType = index === -1 ? "" : devices[index].type;

  dispatch(recallSetDevice({ device: deviceName, type: deviceType }));
};

export const dmDevicesListFetch = () => async dispatch => {
  dispatch(dmDevicesListFetchRequest());
  try {
    const devices = await apiGet("/devices?limit=-1").then(stream =>
      stream.json()
    );

    dispatch(
      dmDevicesListFetchSuccess({
        devices
      })
    );
    dispatch(setDeviceToIssuing());
  } catch (err) {
    dispatch(dmDevicesListFetchError(err));
  }
};

export const processLogDataFetch = () => async (dispatch, getState) => {
  dispatch(processLogDataFetchRequest());

  const { modalData } = submissionPropsSelector(getState());
  const submissionID = modalData.submission_id;
  try {
    const processLogData = await apiGet(
      `/eims/process_log?sort=pk&submission_id=${submissionID}&limit=-1`
    ).then(res => res.json());

    dispatch(
      processLogDataFetchSuccess({
        processLogData
      })
    );
  } catch (err) {
    dispatch(processLogDataFetchError(err));
  }
};

// server side searching: first gets an array of submission_id's from eims.forms that match the string,
// then filter the formData to those objects that are in that array
export const getSubmissionKeysMatchingSearchString = () => async (
  dispatch,
  getState
) => {
  const { serverSearchFilter } = submissionPropsSelector(getState());
  try {
    const matchingSubmissionIDs = await apiGet(
      `/eims/portal_form_errors?fields=submission_id&form_data~~*%25${serverSearchFilter}%25&limit=-1`
    )
      .then(res => res.json())
      .then(res => res.map(e => e.submission_id));

    dispatch(
      serverSearchFetchKeysSuccess({
        matchingSubmissionIDs
      })
    );
  } catch (err) {
    dispatch(processLogDataFetchError(err));
  }
};

export const formDataFetch = () => async (dispatch, getState) => {
  dispatch(formDataFetchRequest());

  const { modalData } = submissionPropsSelector(getState());
  const submissionID = modalData.submission_id;

  try {
    const formData = await apiGet(
      `/eims/forms/${submissionID}?fields=form_data&limit=-1`
    ).then(res => res.json());

    dispatch(
      formDataFetchSuccess({
        formData: cloneObject(formData),
        tabularized: tabularizeFormData(formData)
      })
    );
  } catch (err) {
    dispatch(formDataFetchError(err));
  }
};
//  updates the status of the process log to set the error/warnings to 'Unknown/Resolved' etc
export const updateProcessLogStatus = () => async (dispatch, getState) => {
  dispatch(processLogDataFetchRequest());

  const {
    modalDataDetails,
    processLogIndexCheckedArray,
    processLogNewStatus
  } = submissionPropsSelector(getState());

  const updateAllRowsProcessLog = Promise.all(
    processLogIndexCheckedArray.map(index =>
      apiPut(`/eims/process_log/${modalDataDetails[index].pk}`, {
        status: processLogNewStatus
      }).then(res => res.json())
    )
  );
  try {
    const updatedRows = await updateAllRowsProcessLog;
    updatedRows.forEach((updatedRow, index) => {
      dispatch(updateStoredProcessLog({ index, data: updatedRow }));
    });

    dispatch(processLogUpdateSuccess());
  } catch (err) {
    dispatch(processLogUpdateError(err));
  }
};

const refreshOneRow = submissionID => async dispatch => {
  dispatch(updatingRowRequest(submissionID));

  const fieldsToInclude = [
    "submission_id",
    "submitted_dt",
    "form_name",
    "submission_source",
    "submission_device",
    "process_form",
    "count_error",
    "count_warning",
    "was_recalled",
    "is_valid",
    "has_source_file"
  ];
  try {
    const oneRowData = await apiGet(
      `/eims/portal_form_errors?submission_id=${submissionID}&fields=${fieldsToInclude.join()}`
    ).then(res => res.json());

    dispatch(updateOneRow(oneRowData[0]));
    dispatch(updatingRowSuccess(submissionID));
  } catch (err) {
    dispatch(updatingRowError(err));
  }
};

// we dont need to get the namespace, but its a good confirmation that it all worked..
export const recallToDevice = () => async (dispatch, getState) => {
  const { modalData, deviceSelected } = submissionPropsSelector(getState());
  dispatch(updatingRowRequest(modalData.submission_id));
  dispatch(recallToDeviceRequest());
  try {
    const resObj = await apiPost("/recall_device", {
      device_identifier: deviceSelected.device,
      device_type: deviceSelected.type,
      submission_id: modalData.submission_id
    }).then(res => res.json());

    dispatch(updatingRowSuccess(modalData.submission_id));
    dispatch(recallToDeviceSuccess(resObj));
    dispatch(refreshOneRow(modalData.submission_id));
  } catch (err) {
    dispatch(recallToDeviceError(err));
  }
};

export const makeTemplateToDevice = () => async (dispatch, getState) => {
  const { modalData, deviceSelected } = submissionPropsSelector(getState());
  dispatch(updatingRowRequest(modalData.submission_id));
  dispatch(makeTemplateToDeviceRequest());
  try {
    const resObj = await apiPost("/template_device", {
      device_identifier: deviceSelected.device,
      device_type: deviceSelected.type,
      submission_id: modalData.submission_id
    }).then(res => res.json());

    dispatch(updatingRowSuccess(modalData.submission_id));
    dispatch(makeTemplateToDeviceSuccess(resObj));
    dispatch(refreshOneRow(modalData.submission_id));
  } catch (err) {
    dispatch(makeTemplateToDeviceError(err));
  }
};

// on succes,, change process log store, update process_form to false.

const submissionDataFetch = () => async (dispatch, getState) => {
  dispatch(submissionDataFetchRequest());

  const apiFilters = [];
  let dateFilter = "";

  const {
    rangeFilter,
    errorFilter,
    serverSearchFilter
  } = submissionPropsSelector(getState());
  if (serverSearchFilter) {
    apiFilters.push(
      encodeURIComponent(`form_data~~*%${serverSearchFilter.trim()}%`)
    );
  }
  // Setup up minimum date to search in, translated from 'Select Range' select box
  if (rangeFilter) {
    // timeUnit is either 'Months' or 'Years'
    const [timeNumber, timeUnit] = rangeFilter.split(" ");
    const range = moment()
      .subtract(timeNumber, timeUnit)
      .format("YYYY-MM-DD");
    dateFilter = `submitted_dt>${range}`;
    apiFilters.push(dateFilter);
  }
  if (errorFilter) {
    if (errorFilter === "All") {
      apiFilters.push("hint!=null");
    } else {
      // Hint filter - hint is a field in eims.process_log, specifies type of error
      apiFilters.push(`hint@>{${errorFilter}}`);
    }
  }

  const fieldsToInclude = [
    "submission_id",
    "submitted_dt",
    "form_name",
    "submission_source",
    "submission_device",
    "process_form",
    "count_error",
    "count_warning",
    "was_recalled",
    "is_valid",
    "has_source_file"
  ];
  try {
    const formSubmissions = await apiGet(
      `/eims/portal_form_errors?fields=${fieldsToInclude.join()}&limit=-1&sort=-submitted_dt&${apiFilters.join(
        "&"
      )}`
    ).then(res => res.json());

    dispatch(
      submissionDataFetchSuccess({
        formSubmissions
      })
    );
  } catch (err) {
    dispatch(submissionDataFetchError(err));
  }
  // .then(dispatch(getSubmissionKeysMatchingSearchString()))
};

// this is Delete form and Undelete in one, since it just toggles process_form
export const toggleProcessForm = () => async (dispatch, getState) => {
  const { modalData } = submissionPropsSelector(getState());
  dispatch(processLogUdateRequest());
  dispatch(updatingRowRequest(modalData.submission_id));
  try {
    const resObj = await apiPut(`/eims/forms/${modalData.submission_id}`, {
      process_form: !modalData.process_form
    }).then(res => res.json());

    dispatch(updatingRowSuccess(resObj.submission_id));

    dispatch(
      updateFormDataProcessForm({
        submission_id: resObj.submission_id,
        process_form: resObj.process_form
      })
    );
  } catch (err) {
    dispatch(updatingRowError(err));
  }
};

export const changeOrderSave = () => async (dispatch, getState) => {
  const {
    formData,
    changeOrderSubmissionID,
    modalData
  } = submissionPropsSelector(getState());
  const alteredDT = `${moment(formData[changeOrderSubmissionID].submitted_dt)
    .subtract(1, "seconds")
    .utc()
    .format("YYYY-MM-DDTHH:mm:ss.SSS")}Z`;

  // get the time of the form, use moment to subtract one second, make that the new time,
  // apiPut to update the time of the form
  try {
    await apiPut(`/eims/forms/${modalData.submission_id}`, {
      submitted_dt: alteredDT
    });
    dispatch(submissionDataFetch());
  } catch (err) {
    dispatch(changeOrderError());
  }

  // when all the updates are done, trigger reload modal data
  // dispatch(processLogUpdateSuccess());
};

export const submissionDataFetchIfNeeded = () => (dispatch, getState) => {
  const { isFetching } = submissionPropsSelector(getState());

  // refresh sub status table every time the view component loads- otherwise data remains when new user logs in
  if (isFetching !== true) {
    dispatch(submissionDataFetch());
  }
};

export const getSourceFile = () => (dispatch, getState) => {
  dispatch(formSourceFetchRequest());

  const { modalData } = submissionPropsSelector(getState());
  const submissionID = modalData.submission_id;
  let filename;
  apiGet(`/eims/forms/source/${submissionID}`)
    .then(res => {
      filename = getFilenameFromContentDisposition(
        res.headers.get("content-disposition")
      );
      return res.blob();
    })
    .then(res => {
      saveAs(res, filename);
      dispatch(formSourceFetchSuccess());
    })
    .catch(err => dispatch(formSourceFetchError(err)));
};

// get list of all unique submission errors in eims.proccess_log
export const getSubmissionErrorList = () => async dispatch => {
  dispatch(submissionErrorListRequest());
  await apiGet("/eims/submission_error_list")
    .then(res => res.json())
    .then(errorList => dispatch(submissionErrorListSuccess(errorList)))
    .catch(err => dispatch(submissionErrorListError(err)));
};

export const updateFiltersFromQuery = urlParams => async dispatch => {
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of urlParams.entries()) {
    if (key === "rangeFilter") {
      dispatch(setRangeFilter(Immutable.fromJS(value)));
    } else if (key === "errorFilter") {
      dispatch(setErrorClassFilter(Immutable.fromJS(value)));
    } else if (key === "searchFilter") {
      dispatch(setSearchFilter(Immutable.fromJS(value)));
    } else if (key === "serverSearchFilter") {
      dispatch(setServerSearchFilter(Immutable.fromJS(value)));
    }
  }
};
